import { Contact } from '@/models/generics'
import { AccountingDetails, CompanyRegistration, Financial, InvoiceMeta, Tax } from '@/models/interfaces/company-details'
import { CtClient } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      required: true
    },
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      required: true
    },
    logo_uri: {
      field: 'logo_uri',
      label: 'Logo Uri',
      validator: () => true,
      type: 'string',
      required: false
    },
    tax: {
      field: 'tax',
      label: 'Tax',
      validator: () => true,
      type: 'json',
      required: false,
      default: Object.fromEntries(Object.values(Tax).map(key => ([key, ''])))
    },
    company_name: {
      field: 'company_name',
      label: 'Company Name',
      validator: () => true,
      type: 'string',
      required: false
    },
    company_registration: {
      field: 'company_registration',
      label: 'Company Registration',
      validator: () => true,
      type: 'json',
      required: false,
      default: Object.fromEntries(Object.values(CompanyRegistration).map(key => ([key, ''])))
    },
    company_address: {
      field: 'company_address',
      label: 'Company Address',
      validator: () => true,
      type: 'json',
      required: false,
      default: {
        street: '',
        number: '',
        zipcode: '',
        city: '',
        country: '',
        department: ''
      }
    },
    billing_address: {
      field: 'billing_address',
      label: 'Billing Address',
      validator: () => true,
      type: 'json',
      required: false,
      default: {
        street: '',
        number: '',
        zipcode: '',
        city: '',
        country: '',
        department: ''
      }
    },
    contact: {
      field: 'contact',
      label: 'Contact',
      validator: () => true,
      type: 'json',
      required: false,
      default: Object.fromEntries(Object.values(Contact).map(key => ([key, ''])))
    },
    financial: {
      field: 'financial',
      label: 'Financial',
      validator: () => true,
      type: 'json',
      required: false,
      default: Object.fromEntries(Object.values(Financial).map(key => ([key, ''])))
    },
    invoice_meta: {
      field: 'invoice_meta',
      label: 'Invoice Meta',
      validator: () => true,
      type: 'json',
      required: false,
      default: Object.fromEntries(Object.values(InvoiceMeta).map(key => ([key, ''])))
    },
    accounting_details: {
      field: 'accounting_details',
      label: 'Accounting Details',
      validator: () => true,
      type: 'json',
      required: false,
      default: Object.fromEntries(Object.values(AccountingDetails).map(key => ([key, ''])))
    }

  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}
const options = {}

export default ContentModule<CtClient>(
  ContentType.Client, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions,
  options)
